<div class="title" *ngIf="_data.status === _JoinStatus.owned">
  그룹책을 만든이가 그룹책 그만보기를 선택하면, 이후 그룹책 멤버들도 새로운
  기록을 남길 수 없습니다. 또한 해당 그룹책에 남긴 내 기록은 모두 삭제되고,
  삭제된 기록은 복원이 불가능합니다. 정말로 그룹책 그만보기를 선택하시겠습니까?
</div>
<div class="title" *ngIf="_data.status === _JoinStatus.joined">
  그룹책 그만보기를 선택하면 이 그룹책에 남긴 내 기록은 모두 삭제되고, 삭제된
  기록은 복원이 불가능합니다. 정말로 그룹책 그만보기를 선택하시겠습니까?
</div>
<div class="description">
  이 그룹책에 남긴 나의 댓글과 밑줄을 '나의책'으로 복사해 옮길 수 있습니다.
</div>
<div class="actions">
  <div class="checkboxes">
    <sui-checkbox type="boxFirst">
      내 댓글, 밑줄 복사하기
      <input type="checkbox" [(ngModel)]="_exitCheckboxCopy" />
    </sui-checkbox>
    <sui-checkbox type="boxFirst">
      위 내용을 모두 확인하였습니다.
      <input type="checkbox" id="confirm" [(ngModel)]="_exitCheckboxConfirm" />
    </sui-checkbox>
  </div>
  <div class="buttons">
    <button
      sui-solid-button
      varSize="medium40:large"
      (click)="_onOKClick()"
      [disabled]="!_exitCheckboxConfirm || _isExiting"
    >
      그룹책 그만보기
    </button>
  </div>
</div>
